import { capabilitiesFor } from '@plathunt/types';
/**
 * Gast ist First-Class. Kein Codepfad darf einen Login voraussetzen.
 * Account und PSN-Account bleiben getrennte Konzepte.
 */
export const guestState = { kind: 'guest' };
export function accountState(profile) {
    return { kind: 'account', profile };
}
export function psnLinkedState(profile, psnAccount) {
    return { kind: 'psn_linked', profile, psnAccount };
}
export { capabilitiesFor };
export function progressTargetFor(state) {
    return capabilitiesFor(state).cloudSync ? 'cloud' : 'local';
}
export class PsnOwnershipVerifierNotImplemented {
    issueCode() {
        return Promise.reject(new Error('PSN Ownership Verification kommt in Phase 3.'));
    }
    verify() {
        return Promise.reject(new Error('PSN Ownership Verification kommt in Phase 3.'));
    }
}
//# sourceMappingURL=session.js.map